import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t border-gold/40 bg-navy-deep" data-id="element-76" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-3xl px-3 py-5 text-center sm:px-6" data-id="element-77" data-mp="3ghc3g4fxp7pa">
        <p className="text-[0.66rem] font-extrabold uppercase tracking-[0.12em] text-gold sm:text-[0.72rem]" data-id="element-78" data-mp="32p5lqdx4usnq">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-2 text-[0.64rem] leading-snug text-ivory/90 sm:text-[0.7rem]" data-id="element-79" data-mp="3ueigrjhw2e74">
          INGLÉS ESENCIAL 1™ es un producto educativo. Los resultados de
          aprendizaje dependen de factores individuales como práctica,
          constancia, conocimientos previos y tiempo dedicado. El programa está
          diseñado para desarrollar bases iniciales de inglés y no promete
          fluidez completa ni certificación oficial del idioma.
        </p>
        <p className="mt-2 text-[0.68rem] text-ivory sm:text-[0.74rem]" data-id="element-80" data-mp="2a1jm1gr10865">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-gold underline underline-offset-2" data-id="element-81" data-mp="2evx8uurmh6z7">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-1 text-[0.64rem] text-ivory/90 sm:text-[0.7rem]" data-id="element-82" data-mp="3gctpopi22rrv">
          Términos y Condiciones • Política de Privacidad • Contacto
        </p>
      </div>
    </footer>;
}